<template lang="pug">
#modal-detalhes
    el-dialog.modal-atualizacao(
        title='Monitoramento de bases de dados',
        width='800px',
        :visible.sync='show',
        @close='closeDialog()',
        destroy-on-close
    )
        el-table.tabela(:data='camadas')
            el-table-column(
                prop='nome',
                label='Base de dados',
                width='500',
                align='center'
            )
            el-table-column(
                prop='dataAtualizacao',
                label='Última atualização',
                align='center'
            )
</template>

<script>
import { CamadasService } from '@/services/CamadasService.js';

export default {
    name: 'ModalAtualizacaoBases',

    props: {
        show: Boolean
    },

    data() {
        return {
            camadas: [],
            localShow: this.show
        };
    },

    watch: {
        show(newValue) {
            this.localShow = newValue;
        }
    },

    async created() {
        const response = await CamadasService.ultimaAtualizacao();
        if (response.data !== '') {
            if (response.data && typeof response.data === 'string') {
                this.camadas = JSON.parse(response.data);
            } else {
                this.camadas = response.data;
            }
        }
    },

    methods: {
        closeDialog() {
            this.localShow = false;
            this.$emit('update:show', false);
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-atualizacao {
    height: 90vh;
}

.tabela {
    height: 78vh;
    overflow-y: scroll !important;
}
</style>
